export enum RegepInvoiceProcessType {
  Due = 1,
  Credit,
}
